import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const getAudience = async (search, status, type) => {
    let values = {};
    values.search = search;
    if (status != null) {
        values.status = status;
    }
    if (type != null) {
        values.type = type;
    }

    const res = await axios.post(`${API_URL}audience-management/get-audience`, {
        ...values,
    });
    return res;
};
export const getAttributeValues = async (attributeName) => {
    const res = await axios.post(`${API_URL}common/attributeValues`, {
        attributeName: attributeName,
    });
    return res;
};
export const create_Audience = async (formData) => {
    const userId = localStorage.getItem('userId');
    formData.append('userId', userId);

    const res = await axios.post(`${API_URL}audience-management/create-audience`, formData);

    return res;
};
export const edit_Audience = async (formData) => {
    const userId = localStorage.getItem('userId');
    formData.append('userId', userId);

    const res = await axios.post(`${API_URL}audience-management/edit-audience`, formData);

    return res;
};

export const convertAudienceType = async (audienceId, firebaseTopic) => {
    const res = await axios.post(`${API_URL}audience-management/convert-audience-type`, {
        audienceId: audienceId,
        firebaseTopic: firebaseTopic
    });
    return res;
};
